import { NgModule } from '@angular/core';
import { MinimalScrollbarComponent } from './minimal-scrollbar.component';



@NgModule({
  declarations: [MinimalScrollbarComponent],
  imports: [],
  exports: [MinimalScrollbarComponent]
})
export class MinimalScrollbarModule { }
